import type { DropdownOption } from '../../../shared/ui/forms/SearchableDropdown';

/**
 * Pure dropdown-option builders shared by the scope-editor section wrappers
 * (Process Conditions / Project Properties). Kept React-free per the
 * mapping-configuration boundary: components own store access, these
 * helpers only shape option lists.
 */

export interface PreviousPageOptionSource {
  value?: string | null;
  label: string;
  source: string;
}

export function buildPreviousPagesOptions(
  sources: PreviousPageOptionSource[]
): DropdownOption[] {
  return sources
    .filter((source) => source.value)
    .map((source) => ({
      value: source.value as string,
      label: source.label,
      tooltip: `From ${source.source}`,
      group: source.source,
    }));
}

export function buildPcfAttributeOptions<K extends string>(
  keys: readonly K[],
  defaultNames: Record<K, string>,
  groupFor: (attributeName: string) => string
): DropdownOption[] {
  return keys.map((key) => {
    const name = defaultNames[key];
    return { value: name, label: name, group: groupFor(name) };
  });
}
